import axios from 'axios'

export default class Usuario {
  constructor(tokenBearer, url) {
    this.url = `${url}/api/meuUsuario`
    this.tokenBearer = tokenBearer
  }
  getUser() {
    return new Promise(async (resolve, reject) => {
      let optionsUser = {
        method: 'get',
        url: `${this.url}/meusDados`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseUser = await axios(optionsUser)
        resolve(responseUser)
      } catch (err) {
        reject(err)
      }
    })
  }

  getUnimed() {
    return new Promise(async (resolve, reject) => {
      let optionsUnimed = {
        method: 'get',
        url: `${this.url}/minhaUnimed`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseUnimed = await axios(optionsUnimed)
        resolve(responseUnimed)
      } catch (err) {
        reject(err)
      }
    })
  }

  getTokenLegado() {
    return new Promise(async (resolve, reject) => {
      let optionsUnimed = {
        method: 'get',
        url: `${this.url}/tokenLegado`,
        headers: {
          Authorization: this.tokenBearer
        }
      }

      try {
        let responseUnimed = await axios(optionsUnimed)
        resolve(responseUnimed)
      } catch (err) {
        reject(err)
      }
    })
  }

  putData(data) {
    return new Promise(async (resolve, reject) => {
      let optionsData = {
        method: 'put',
        url: `${this.url}/meusDados`,
        headers: {
          Authorization: this.tokenBearer
        },
        data
      }

      try {
        let responseData = await axios(optionsData)
        resolve(responseData)
      } catch (err) {
        reject(err)
      }
    })
  }

  putImage(image) {
    return new Promise(async (resolve, reject) => {
      let optionsImage = {
        method: 'put',
        url: `${this.url}/foto`,
        headers: {
          Authorization: this.tokenBearer,
          'Content-Type': 'multipart/form-data'
        },
        data: image
      }

      try {
        let responseImage = await axios(optionsImage)
        resolve(responseImage)
      } catch (err) {
        reject(err)
      }
    })
  }

  delImage() {
    return new Promise(async (resolve, reject) => {
      let optionsImage = {
        method: 'delete',
        url: `${this.url}/foto`,
        headers: {
          Authorization: this.tokenBearer,
          'Content-Type': 'multipart/form-data'
        }
      }

      try {
        let responseImage = await axios(optionsImage)
        resolve(responseImage)
      } catch (err) {
        reject(err)
      }
    })
  }
}
